var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.keyword)+" in "+_vm._s(_vm.category)+":第"+_vm._s(_vm.page)+"页/共"+_vm._s(_vm.totalPage)+"页")])])}
var staticRenderFns = []

export { render, staticRenderFns }